<template>
    <form class="help" @submit.prevent="sendEmail" v-if="!emailSent">
        <h4>Deixe aqui o seu feedback para podermos melhorar de forma contínua a sua experiência nesta plataforma</h4>
        <label>
            <div class="label">Assunto</div>
            <input type="text" v-model="helpSubject">
        </label>
        <label>
            <div class="label">Feedback</div>
            <textarea type="text" v-model="helpBody"></textarea>
        </label>
        <div v-if="previewFile">
            <h3>Anexo: {{ fileName }}</h3>
        </div>
        <label for="upload">
            <input type="file" id="upload" name="image" ref="input" @change="previewFile">
            <div class="label">Anexar</div>
        </label>
        <button type="submit" v-if="helpSubject && helpBody">Enviar</button>
        <p>{{ formatMessage }}</p>
    </form>
    <p class="emailSent" v-if="emailSent">{{ emailSent }}</p>
</template>

<script>
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

export default {
    name: 'HelpPage',

    data() {
        return {
            helpSubject: '',
            helpBody: '',
            emailSent: '',
            file: null,
            fileName: '',
            formatMessage: '',
        }
    },

    methods: {
        previewFile() {
            const file = this.$refs.input.files[0]
            if (file) {
                if (file.size > 5 * 1024 * 1024) {
                    this.formatMessage = "O ficheiro é muito grande. O limite são 5MB."
                    this.file = null
                    this.fileName = ""
                    return;
                }
                const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "application/pdf"]
                if (!allowedTypes.includes(file.type)) {
                    this.formatMessage = "Formato do ficheiro inválido. Apenas imagens e PDFs são permitidos."
                    this.file = null
                    this.fileName = ""
                    return;
                }

                this.file = file
                this.fileName = file.name
            }
        },

        async uploadFile() {
            if (this.file == null) {
                return;
            }

            try {
                const storage = getStorage();
                const storageRef = ref(storage, this.filePath)
                const snapshot = await uploadBytes(storageRef, this.file)
                return await getDownloadURL(snapshot.ref)
            } catch (error) {
                console.log("Erro ao adicionar ficheiro:", error)
                return ''
            }
        },

        async sendEmail() {
            await this.uploadFile();

            await this.$store.dispatch('users/sendHelpEmail', {
                subject: this.helpSubject,
                body: this.helpBody,
                file: this.filePath
            });

            this.helpSubject = ''
            this.helpBody = ''
            this.file = ""
            this.fileName = ''
            this.emailSent = 'Obrigado pela sua mensagem.'
        },
    },

    computed: {
        currentUser() {
            return this.$store.state.users.currentUser
        },
        filePath() {
            if (this.file) {
                return `${this.instanceId}/help/${this.file.name}`
            }
            return ""
        },
        instanceId() {
            return this.$store.state.instanceId
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.help {
    margin: 1rem 2rem;
    width: -webkit-fill-available;
    background: var(--sidebar-bg-color);
    border-radius: 10px;
    padding: 1rem;


    h1 {
        text-transform: capitalize;
    }

    h3 {
        margin: 1rem;
    }

    label {
        margin: 1em;

        input[type=file] {
            display: none;

            &+.label {
                padding: 1rem;
                border: 2px dashed;
                border-radius: 10px;
                width: fit-content;
            }
        }

        input,
        textarea {
            outline: none;
            padding: .5rem;
            width: 100%;
            background-color: var(--bg-color-2);
            border: 2px solid var(--bg-color-2);
            color: var(--text-color);
            border-radius: 5px;

            &:focus {
                border: 2px solid var(--highlight-color);
                box-shadow: 0 0 0 1px var(--highlight-color), inset 0 0 0 1px var(--highlight-color);
            }
        }

        textarea {
            height: 300px;
        }

        img {
            max-width: 50px;
            max-height: 50px;
        }
    }

    button {
        margin-bottom: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1rem;
        width: 100%;
        flex: 1;
        padding: .5rem;
        font-size: 18px;
        cursor: pointer;
        text-align: center;
        border: none;
        border-radius: 5px;
        background-color: var(--text-color);
        color: var(--white);
        transition: background-color 0.3s ease;

        &:hover {
            background-color: var(--highlight-color, 10%);
        }

        &[type="button"] {
            background-color: var(--text-darken-color);

            &:hover {
                background-color: var(--secondary-color);
            }
        }
    }

}

.emailSent {
    margin: auto;
}
</style>
